import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import '../../../css/thankyou.css';

const ThankYou = () => {
  const navigate = useNavigate();
  const [isVisible, setIsVisible] = useState(false);
  const [progress, setProgress] = useState(0);

  // Get time-based goodbye message
  const getGoodbyeMessage = () => {
    const hour = new Date().getHours();
    
    if (hour >= 6 && hour < 12) {
      return {
        main: "Good Job Today!",
        sub: "Wah, you started early ah! Thanks for using POSlah! Time to rest and recharge... Come back stronger tomorrow! See you again soon!"
      };
    } else if (hour >= 12 && hour < 18) {
      return {
        main: "Great Work!",
        sub: "Afternoon warrior! You worked damn hard today leh! Thanks for choosing POSlah... Take a break, you deserve it! Until next time!"
      };
    } else {
      return {
        main: "Well Done!",
        sub: "Evening shift complete! Solid work today bro! Thanks for trusting POSlah... Time to lepak and enjoy your evening! See you tomorrow!"
      };
    }
  };

  const goodbye = getGoodbyeMessage();

  useEffect(() => {
    // Trigger animations
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 300);

    // Progress bar animation
    const progressInterval = setInterval(() => {
      setProgress(prev => {
        if (prev >= 100) {
          clearInterval(progressInterval);
          return 100;
        }
        return prev + 2;
      });
    }, 70); // 5 seconds total (100/2 * 100ms = 5000ms)

    // Navigate to signin after 5 seconds
    const redirectTimer = setTimeout(() => {
      navigate('/signin', { replace: true });
    }, 5000); // 5 seconds

    return () => {
      clearTimeout(timer);
      clearTimeout(redirectTimer);
      clearInterval(progressInterval);
    };
  }, [navigate]);

  return (
    <div className="thankyou-screen">
      <div className="thankyou-container-new">
        {/* Main Goodbye */}
        <div className={`goodbye-main ${isVisible ? 'fade-in-up' : ''}`}>
          <h1 className="main-goodbye">
            {goodbye.main}
          </h1>
        </div>

        {/* Sub Message */}
        <div className={`goodbye-sub ${isVisible ? 'fade-in-up-delayed' : ''}`}>
          <p className="sub-goodbye-message">
            {goodbye.sub}
          </p>
        </div>

        {/* Progress Indicator */}
        <div className={`progress-section-bye ${isVisible ? 'fade-in-up-more-delayed' : ''}`}>
          <div className="progress-bar-bye">
            <div 
              className="progress-fill-bye"
              style={{ width: `${progress}%` }}
            />
          </div>
          <div className="progress-text-bye">{Math.round(progress)}%</div>
        </div>

        {/* Loading Dots */}
        <div className={`loading-dots-bye ${isVisible ? 'fade-in-last' : ''}`}>
          <span className="dot-bye"></span>
          <span className="dot-bye"></span>
          <span className="dot-bye"></span>
        </div>

        {/* Thank You Note */}
        <div className={`thank-note ${isVisible ? 'fade-in-final' : ''}`}>
          <p className="appreciation-text">
            Thank you for choosing POSlah! 🙏
          </p>
        </div>
      </div>

      {/* Background Animation */}
      <div className="bg-particles-bye">
        <div className="particle-bye particle-bye-1"></div>
        <div className="particle-bye particle-bye-2"></div>
        <div className="particle-bye particle-bye-3"></div>
        <div className="particle-bye particle-bye-4"></div>
        <div className="particle-bye particle-bye-5"></div>
        <div className="particle-bye particle-bye-6"></div>
      </div>
    </div>
  );
};

export default ThankYou;